import { render, staticRenderFns } from "./pagesForm.vue?vue&type=template&id=f442cc70"
import script from "./pagesForm.vue?vue&type=script&lang=js"
export * from "./pagesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports